import VanillaTilt from 'vanilla-tilt';

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    return {
      provide: {
        VanillaTilt,
      },
    };
  }
})